import { render } from "./AttachProductListComponent.vue?vue&type=template&id=4549257d"
import script from "./AttachProductListComponent.vue?vue&type=script&lang=js"
export * from "./AttachProductListComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__